import Vue from 'vue'

export default {
    UPDATE_PLAYLIST (state, value) {
        Vue.set(state, 'playlists', value);
    },
    SET_PLAYLIST (state, value) {
        this.commit('UPDATE_PLAYLIST', value);
    },
    SET_SELECTED_PLAYLIST (state,  value ) {
      Vue.set(state, 'selectedPlaylist', value);
    },
    SET_FILTER_RESULTS (state,  value ) {
      Vue.set(state, 'filterResults', value);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/playlists/mutations.js